<template>
  <div class="aff-login-page">
    <div class="aff-login-card">
      <div class="aff-login-logo">
        <img src="https://img.jiliskin.com/jili_logo_600.png" alt="JiLi 肌黎" class="aff-logo-img" @error="$event.target.style.display='none'" />
        <h1>忘記密碼</h1>
        <p class="aff-sub">輸入您的 Email 或登入帳號，我們將寄送重設連結至您的信箱</p>
      </div>

      <form @submit.prevent="submit" class="aff-login-form">
        <div class="aff-field">
          <label>Email 或帳號</label>
          <input v-model="loginInput" type="text" placeholder="請輸入 Email 或登入帳號" required />
        </div>

        <div v-if="error" class="aff-error">{{ error }}</div>
        <div v-if="success" class="aff-success">{{ success }}</div>

        <button type="submit" class="aff-btn-login" :disabled="loading || !!success">
          {{ loading ? '寄送中...' : '寄送重設連結' }}
        </button>

        <p class="aff-apply-link"><a href="/affiliate/login">← 返回登入</a></p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

const loginInput = ref('')
const loading = ref(false)
const error = ref('')
const success = ref('')

async function submit() {
  error.value = ''
  success.value = ''
  loading.value = true
  try {
    const res = await axios.post('/api/affiliate/forgot-password', { login: loginInput.value.trim() })
    if (res.data.success) {
      success.value = res.data.message
    } else {
      error.value = res.data.message || '操作失敗'
    }
  } catch (e) {
    error.value = e.response?.data?.message || '伺服器錯誤，請稍後再試'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.aff-login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f0eb 0%, #ede0d4 100%);
  display: flex; align-items: center; justify-content: center; padding: 2rem 1rem;
}
.aff-login-card {
  background: #fff; border-radius: 16px; box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 2.5rem 2rem; width: 100%; max-width: 400px;
}
.aff-login-logo { text-align: center; margin-bottom: 1.5rem; }
.aff-logo-img { height: 48px; margin-bottom: 0.5rem; }
.aff-login-logo h1 { font-size: 1.4rem; color: #4a2c1a; margin: 0.3rem 0; }
.aff-sub { color: #888; font-size: 0.85rem; margin: 0.3rem 0 0; }
.aff-login-form { display: flex; flex-direction: column; gap: 1rem; }
.aff-field { display: flex; flex-direction: column; gap: 0.3rem; }
.aff-field label { font-size: 0.85rem; font-weight: 600; color: #555; }
.aff-field input {
  border: 1px solid #ddd; border-radius: 8px; padding: 0.6rem 0.9rem;
  font-size: 0.95rem; outline: none; transition: border-color 0.2s;
}
.aff-field input:focus { border-color: #8B4513; }
.aff-error { background: #fff0f0; color: #c0392b; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-success { background: #f0fff4; color: #27ae60; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-btn-login {
  background: #8B4513; color: #fff; border: none; border-radius: 8px;
  padding: 0.8rem; font-size: 1rem; font-weight: 600; cursor: pointer; transition: background 0.2s;
}
.aff-btn-login:hover:not(:disabled) { background: #6b3310; }
.aff-btn-login:disabled { background: #ccc; cursor: not-allowed; }
.aff-apply-link { text-align: center; font-size: 0.88rem; color: #666; margin-top: 0.3rem; }
.aff-apply-link a { color: #8B4513; font-weight: 600; }
</style>
